function getContrastYIQ(
  hexcolor,
  threshold = 128,
  darkAmount = -150,
  lightAmount = 150,
) {
  // Remove hash at the start if it's there
  hexcolor = hexcolor.replace('#', '')

  let r = parseInt(hexcolor.substr(0, 2), 16)
  let g = parseInt(hexcolor.substr(2, 2), 16)
  let b = parseInt(hexcolor.substr(4, 2), 16)

  // Calculate the YIQ based on the color
  let yiq = (r * 299 + g * 587 + b * 114) / 1000

  // Adjust the color lightness or darkness
  function adjustColor(amount) {
    r = Math.min(255, Math.max(0, r + amount))
    g = Math.min(255, Math.max(0, g + amount))
    b = Math.min(255, Math.max(0, b + amount))

    r = ('0' + r.toString(16)).slice(-2)
    g = ('0' + g.toString(16)).slice(-2)
    b = ('0' + b.toString(16)).slice(-2)

    return '#' + r + g + b
  }

  // Decide whether to lighten, darken, or use black/white for contrast
  if (yiq >= threshold) {
    return adjustColor(darkAmount) // Darken color
  } else {
    return adjustColor(lightAmount) // Lighten color
  }
}

export default getContrastYIQ